import { WEB_URL } from "@/config/endpoints";
import IMAGES from "@/public/assets/img";


export default {
  SeoContent:{
    title: "Credlix Partner program",
    url: WEB_URL+'/partner-program',
    name:'description',
    description:'Empower your clients with instant, collateral-free capital',
    keyword: 'Partner program', 
    imagePath:IMAGES.HOMEIMG.bigLogoNew.src
  },
  banner: {
    bannerHeading:
      "Set Yourself Apart with Credlix’s ​Instant Working Capital for Your Clients​",
    imagePath: IMAGES?.partnerProgram?.partnerlogo,
  },
  partnerBenefitsText: {
    imagePath: IMAGES?.partnerProgram?.partnerGrow,
    subheadline: "Empower your clients with instant, collateral-free capital.",
    description:
      "As a partner, you’re not just another participant; you’re a key player in a community that values innovation and excellence. With Credlix Xcelerate, you’ll access resources that drive success.",
    partnerbg:
      "Partner <span style='background-color: #FFD700; color: #022B5C;padding: 0px 5px;'>Benefits</span>",
  },
  partnerBenefits: [
    {
      title: "Earn high commissions",
      description:
        "By offering cutting-edge, collateral-free financing solutions. Lowest Rates In Invoice Discounting",
      icon: IMAGES?.partnerProgram?.Earnlogo,
    },
    {
      title: "Start earning",
      description:
        "Access fast, seamless onboarding from day one. Quickest Disbursal of funds",
      icon: IMAGES?.partnerProgram?.startEarning,
    },
    {
      title: "Boost your business",
      description:
        "Benefit from dedicated partner support and co-marketing opportunities",
      icon: IMAGES?.partnerProgram?.boostBusiness,
    },
    {
      title: "Global Network",
      description:
        "Leverage Credlix’s Global network to unlock new business opportunities and growth.",
      icon: IMAGES?.partnerProgram?.networklogo,
    },
  ],

  GlobalExpansion: {
    heading:
      "From Local Roots To <span style='font-weight: 700;'>Global Expansion</span>",
    imagePath: IMAGES?.partnerProgram?.globalImage,
  },
  mainContent: {
    sections: [
      {
        headline: "Extensive Reach",
        description:
          "With offices in Singapore, USA, India, UAE, and Mexico, Credlix offers localized support and expertise to clients worldwide.",
      },
      {
        headline: "Impactful Partnerships",
        description:
          "Serving over 700 enterprises, 20,000+ suppliers, and 500,000+ SMEs, Credlix is committed to fostering sustainable growth and resilience.",
      },
      {
        headline: "Driving Innovation",
        description:
          "Through our digital platform and seamless processes, we empower businesses to thrive in the ever-evolving landscape of global trade.",
      },
    ],
  },
  statistics: [
    {
      icon: IMAGES?.partnerProgram?.funds,
      title: "$500+ mn",
      description: "Funds Disbursed",
    },
    {
      icon: IMAGES?.partnerProgram?.staffing,
      title: "5000+",
      description: "MSMEs Onboarded",
    },
    {
      icon: IMAGES?.partnerProgram?.cities,
      title: "120+",
      description: "Cities across the Globe",
    },
  ],

  Partnership: "Partnership Journey​",
  PartnershipData: [
    {
      id: 1,
      title: "Join Credlix Xcelerate",
      descriptionHeading: "Sign Up: ",
      description: "Unlock tailored support and start earning with every deal.",
      isActive: true,
      image: IMAGES?.partnerProgram?.signup,
    },
    {
      id: 2,
      title: "Connect Us with Your Clients",
      descriptionHeading: "Seamless Onboarding: ",
      description: "We handle the process, you enjoy the rewards.",
      descriptionHeading2: "Boost Their Business: ",
      description2: "Offer them top-tier financing solutions.",
      isActive: false,
      image: IMAGES?.partnerProgram?.connect,
    },
    {
      id: 3,
      title: "Reap the Rewards of Success",
      descriptionHeading: "Global Network: ",
      description: "Access new opportunities in 90+ countries.",
      descriptionHeading2: "Earn More: ​",
      description2: "Enjoy competitive commissions and exclusive bonuses.",
      isActive: false,
      image: IMAGES?.partnerProgram?.rewardspartner,
    },
  ],

  boostEarnings: {
    exportHeading: "Boost your earnings with diverse financial solutions.​",
    exportSubHeading:
      "OFFER <span style='font-weight: 700;'>UP TO 90%</span> OF CLIENT INVOICE VALUE WITHIN <span style='font-weight: 700;'>24 HOURS</span>",
  },
  forExporterMenuItems: [
    {
      name: "Export factoring",
      href: "/export-factoring",
      text: "Get up to 90% of the invoice value upon shipment",
      src: IMAGES.globalBuyer.exportBuyer,
      eventsName: 'PartnerPage_Export_Factoring'
    },
    {
      name: "PO Finance",
      href: "/export-factoring/purchase-order-financing",
      text: "Receive quick and hassle-free advances against confirmed purchase orders",
      src: IMAGES.globalBuyer.financeBuyer,
       eventsName: 'PartnerPage_PO_Finance'
    },
    {
      name: "Sales Bill Discounting",
      href: "/export-factoring/invoice-discounting-platform",
      text: "Discount invoices to improve cash flow and help fund future material movement",
      src: IMAGES.globalBuyer.paymentBuyer,
       eventsName: 'PartnerPage_Sales_Bill_Discounting'
    },
    {
      name: "Early Payment",
      href: "/enterprise/early-payment-discount",
      text: "Streamline cash flow and generate higher returns on your funds.",
      src: IMAGES.partnerProgram.earlyPartner,
       eventsName: 'PartnerPage_Early_Payment'
    },
    {
      name: "Vendor Finance",
      href: "/enterprise/vendor-financing-india",
      text: "Empower your suppliers with discounted accounts receivable in just two clicks",
      src: IMAGES.partnerProgram.vendorPartner,
       eventsName: 'Partner_Vendor_Finance'
    },
    {
      name: "Channel Finance",
      href: "/enterprise/channel-financing-india",
      text: "Enable financing for your distributors through NBFCs and financial institutions",
      src: IMAGES.partnerProgram.FinanciamientoES,
       eventsName: 'Partner_Channel_Finance'
    },
  ],
  FormData: {
    imagePath: IMAGES?.partnerProgram?.tenxFaster,
    Company: "Company",
    Email: "Email",
    name: "Full Name",
    Mobile: "Mobile number",
    Submitbtn: "Apply Now",
    ThankYou: "Successful Submission: Thank you for your interest.",
    requiredMessage: "This field is required.",
    emailMessage: "Email is not valid",
    phoneMessage: "Phone number is not valid",
    phoneMessage2: "The phone number should not start with 0, 1, 2, 3.",
  },
};
